import { render } from "./SplashContainer.vue?vue&type=template&id=4bdb3860&scoped=true"
import script from "./SplashContainer.vue?vue&type=script&lang=js"
export * from "./SplashContainer.vue?vue&type=script&lang=js"

import "./SplashContainer.vue?vue&type=style&index=0&id=4bdb3860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdb3860"]])

export default __exports__